module.exports = __webpack_public_path__ + "img/tools_Sales_Incentive_Market_Practices_Report.5ef5f91f.jpg";